var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb_svg-icon"},[_c('svg',{attrs:{"role":"img"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.iconId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }